import { render, staticRenderFns } from "./update-information.vue?vue&type=template&id=1cdc9690&scoped=true&"
import script from "./update-information.vue?vue&type=script&lang=js&"
export * from "./update-information.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cdc9690",
  null
  
)

export default component.exports